import {
  AutoGenAgent,
  AutoGenInputType,
  SpeakerSelectionMethod,
} from '../../../../frontend/src/app/core/autogen/autogen';
import { WebSocketBackend } from '../../../../frontend/src/app/core/websocket/websocket';
import { StreamingChatRequest } from '../openai/openai.gate';
import { ResourceName } from '../resource-name';

export const WebSocketGate = {
  resource: ResourceName.websocket,
  actions: {
    connect: '$connect',
    disconnect: '$disconnect',
    default: '$default',
    setLocation: 'set-location',
    sendStreamingChat: 'send-streaming-chat',

    checkQuality: 'check-quality',
  },
};

export type WebSocketGateActionTypes = {
  connect: {
    request: undefined;
    response: undefined;
  };
  disconnect: {
    request: undefined;
    response: undefined;
  };
  default: {
    request: undefined;
    response: undefined;
  };
  setLocation: {
    request: Partial<WebSocketBackend>;
    response: undefined;
  };
  checkQuality: {
    request: AssessmentRequest;
    response: undefined;
  };
  sendStreamingChat: {
    request: StreamingChatRequest;
    response: undefined;
  };
};

export const moderatorAgentName = 'Output';
export const criticAgent = 'Critic';

export interface AssessmentRequest {
  workspaceId: string;
  jobId?: string;
  model: string;
  agentList: AutoGenAgent[];
  initMessageList: string[];
  maxRound: number;
  speakerSelectionMethod?: SpeakerSelectionMethod;
  inputType?: AutoGenInputType;
  filePathList?: string[];
  solutionId?: string;
  chatId?: string;
  inputModel?: string;
}

export interface WebSocketResponse {
  senderId?: string;
  type: WebSocketResponseType;
  payload?: any;
}

export enum WebSocketResponseType {
  // Workspace
  updateWorkspace = 'update-workspace',

  onlineUserLocationList = 'online-user-location-list',

  chatMessage = 'chat-message',
  publicPersonChat = 'public-person-chat',
  agentChat = 'agent-chat',
  streamingChat = 'streaming-chat',
  textToSpeech = 'text-to-speech',

  updateCredits = 'update-credits',
}

export interface UpdateCreditsPayload {
  userId: string;
  credits: number;
}
